/**
 * The districts of Kerala.
 *
 * Domain vocabulary, like the roles beside it, which is why it lives here
 * rather than in the data package: the API needs the list to answer "where is
 * your site", and the API does not depend on the seed.
 *
 * s.4(1) constitutes a District Single Window Clearance Board for every one of
 * them, so this list is also the list of district boards.
 */

export interface District {
  en: string;
  ml: string;
}

export const DISTRICTS: readonly District[] = [
  { en: "Thiruvananthapuram", ml: "തിരുവനന്തപുരം" },
  { en: "Kollam", ml: "കൊല്ലം" },
  { en: "Pathanamthitta", ml: "പത്തനംതിട്ട" },
  { en: "Alappuzha", ml: "ആലപ്പുഴ" },
  { en: "Kottayam", ml: "കോട്ടയം" },
  { en: "Idukki", ml: "ഇടുക്കി" },
  { en: "Ernakulam", ml: "എറണാകുളം" },
  { en: "Thrissur", ml: "തൃശ്ശൂർ" },
  { en: "Palakkad", ml: "പാലക്കാട്" },
  { en: "Malappuram", ml: "മലപ്പുറം" },
  { en: "Kozhikode", ml: "കോഴിക്കോട്" },
  { en: "Wayanad", ml: "വയനാട്" },
  { en: "Kannur", ml: "കണ്ണൂർ" },
  { en: "Kasaragod", ml: "കാസർഗോഡ്" },
];

export const KERALA_DISTRICTS: readonly string[] = DISTRICTS.map((d) => d.en);

/** The district whose offices have been checked against the register. */
export const CHECKED_DISTRICT = "Ernakulam";
